module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image19-92b0e6929b9e36f00b8aed73a84dd5a2.jpg";